import React from 'react'
import argustrilogo from "../assets/ArgusTriLogo.png"
import "./DemoHead.css"

function DemoHead() {
  return (
    <div className='demohead-wrapper'>
        <div className="demohead-content">
            <div className='demohead-image-wrapper'>
                <img className='demohead-image' src={argustrilogo} alt='logo'></img>
            </div>
            <div className='demohead-heading'>
                Unlock Smarter Operations <br></br>
                <span>Tell us your needs, and let our AI-driven solutions transform your operations with precision and efficiency.</span>
            </div>
        </div>
    </div>
  )
}

export default DemoHead